const dictList = {
    // 呼叫类型字典
    callTypeList: [
        { id: '0', name: '呼叫站长' },
        { id: '1', name: '呼叫防火员' },
        { id: '2', name: '呼叫中队' },
    ],
    // 所属部门字典
    userDeptTypeList: [
        { id: '0', name: '支队用户' },
        { id: '1', name: '中队用户' },
        { id: '2', name: '大队用户' },
        { id: '3', name: '微站用户' },
        { id: '4', name: '街道用户' },
        { id: '5', name: '物业用户' },
        { id: '9', name: '运营公司' },
    ],
    // 沟通主题
    gtztList: [
        { id: 0,name: '日常汇报' },
        { id: 1,name: '火警求援' },
        { id: 2,name: '隐患求援' },
        { id: 3,name: '其他事项' },
    ],
}
export default dictList



// WEBPACK FOOTER //
// ./src/js/dict.js